import { render, staticRenderFns } from "./PdfThumbComponent2.vue?vue&type=template&id=1b436e98&scoped=true&"
import script from "./PdfThumbComponent2.vue?vue&type=script&lang=js&"
export * from "./PdfThumbComponent2.vue?vue&type=script&lang=js&"
import style0 from "./PdfThumbComponent2.vue?vue&type=style&index=0&id=1b436e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b436e98",
  null
  
)

export default component.exports